module.exports = __webpack_public_path__ + "img/tracking_icons.36a12842.png";